import { Navigate } from '@starsoft/common/components';
import { usePathname, useSearchParams } from '@starsoft/common/hooks';
import styles from './styles.module.scss';
import { Nullable } from '@starsoft/common/interfaces';
import DepositResponseContent from './Content';

/**
 * DepositResponse Component
 * This component is responsible for rendering the response content of a deposit transaction.
 * It checks for the presence of a 'deposit-id' in the URL search parameters and navigates back to the current path if not found.
 *
 * @returns {JSX.Element} The rendered component for the deposit response.
 *
 * @example
 * // Usage example:
 * <DepositResponse />
 */
export default function DepositResponse() {
  // Retrieve the current pathname from the URL
  const pathname: string = usePathname();
  // Retrieve the search parameters from the URL
  const search: URLSearchParams = useSearchParams();
  // Get the 'deposit-id' from the search parameters
  const id: Nullable<string> = search.get('deposit-id');

  // If 'deposit-id' is not found, navigate back to the current pathname
  if (!id) {
    return <Navigate to={pathname} />;
  }

  // Render the deposit response content
  return (
    <div className={styles.container}>
      <div className={styles.container__content}>
        <DepositResponseContent />
      </div>
    </div>
  );
}
